import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Informacoes from '@/views/escritorios/Informacoes'
import AbaEndereco from '@/views/escritorios/AbaEndereco'
import Contato from '@/views/escritorios/Contato'
import { mapState, mapActions, mapGetters } from 'vuex'
import mensagens from '@/util/mensagens'
import { BAlert, BSpinner } from 'bootstrap-vue'
import util from '@/util'
import cnpj from '@/util/cnpj'
import cpf from '@/util/cpf'
import { valorEhCpf, valorEhCnpj } from '@/util/index'
import cadastroUtil from '@/util/cadastroUtil'
import MonitoramentoConsumo from '@/views/consumo/MonitoramentoConsumo.vue'
import RecursosListagem from '@/views/recursos/RecursosListagem.vue'
import ContratoModalVerificaCancelamento from '@/views/recursos/ContratoModalVerificaCancelamento.vue'
import ContratoModalCancelamento from '@/views/recursos/ContratoModalCancelamento.vue'
import Pedidos from '@/views/escritorios/Pedidos.vue'
import Faturas from '@/views/escritorios/Faturas.vue'
import Usuarios from '@/views/escritorios/Usuarios.vue'
import PainelGestaoProdutos from '@/views/escritorios/gestao-produtos/PainelGestaoProdutos.vue'

export default {
  name: 'edicao-escritorio-administracao',
  components: {
    cabecalho,
    Informacoes,
    RecursosListagem,
    AbaEndereco,
    Contato,
    ContratoModalVerificaCancelamento,
    ContratoModalCancelamento,
    menuLateral,
    MonitoramentoConsumo,
    Pedidos,
    Faturas,
    Usuarios,
    PainelGestaoProdutos,
    'b-alert': BAlert,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapState('escritorios', ['formulario', 'dadosRetorno', 'flagsDeControle', 'listaUsuariosRepresentanteLegal', 'gestaoProdutosHabilitado']),
    ...mapGetters('escritorios', ['ehEmpresaOffice']),
    ...mapGetters('gestaoProdutos', { produtosValido: 'formularioValido', produtosCarregado: 'temConfigCarregada' }),
    deveSalvarProdutos () {
      // salva as configs de produto junto do escritório quando a aba está visível e já foi carregada
      return this.visibilidadeAbas.produtos && this.produtosCarregado
    },
    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    },
    ehPessoaFisica () {
      return this.formulario.tipo === 1
    },
    tabelaConsumoSemRegistros () {
      return this.listaConsumos.length === 0
    },
    tabelaRecursoSemRegistros () {
      return this.listaRecursos.length === 0
    },
    obterIdEmpresa () {
      return this.$route.params.id
    }
  },

  data: () => {
    return {
      listaConsumos: [],
      listaRecursos: [],
      informacoesContrato: [],
      fields: [
        { key: 'descricao' },
        { key: 'plano', thClass: 'text-center' },
        { key: 'adicional', thClass: 'text-center' },
        { key: 'utilizado', thClass: 'text-center' },
        { key: 'saldo', thClass: 'text-center' }
      ],
      flagAbas: {
        informacoes: false,
        endereco: false,
        contato: false
      },
      abaSelecionada: {
        informacoes: true,
        endereco: false,
        contato: false,
        produtos: false,
        pedidos: false,
        faturas: false,
        recursos: false,
        usuarios: false
      },
      visibilidadeAbas: {
        informacoes: true,
        endereco: true,
        contato: true,
        produtos: false,
        recursos: false,
        pedidos: false,
        faturas: false,
        usuarios: false
      },
      imagem_logotipo: null
    }
  },

  async mounted () {
    this.ActionResetarDadosRetornoCadastro()
    this.ActionResetarDadosFormularioEscritorio()
    let id = this.$route.params.id
    if (!util.valorEhNulo(id)) {
      await this.obterEscritorio(id)
      this.limparCampos()
      this.definirValorDefaultVisibilidadeAbas()
    }
    this.limparFlagErroNoFormulario()
  },

  methods: {
    ...mapActions('escritorios', [
      'ActionResetarDadosFormularioEscritorio',
      'ActionSalvarEscritorio',
      'ActionObterEscritorio',
      'ActionResetarDadosRetornoCadastro',
      'ActionResetarDadosPessoaisFormularioEscritorio',
      'ActionResetarDadosEmpresariaisFormularioEscritorio'
    ]),
    ...mapActions('auth', ['ActionSetLogoCliente']),
    ...mapActions('gestaoProdutos', ['ActionSalvarProdutos']),
    async buscarInformacoesDoCnpj (cnpj) {
      try {
        const retorno = await this.axios.get(`/consultar/cnpj/${cnpj}`)
        return retorno.data
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async salvarRegistro () {
      const validacaoOk = this.validarDadosFormulario()
      if (!validacaoOk) {
        this.obterAbaDoComErro()
        return
      }
      // valida as configurações de produto (quando aplicável) antes de salvar tudo numa ação só
      if (this.deveSalvarProdutos && !this.produtosValido) {
        util.criarAlertaToastDeErro(this, 'Atenção', 'Preencha os campos obrigatórios dos produtos ativos.')
        this.selecionarAba('produtos')
        return
      }
      await this.executarSalvarRegistro()
    },
    async obterEscritorio (id) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        await this.ActionObterEscritorio(id)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    obterDadosFormularioInformacoesAdicionais () {
      if (this.ehPessoaFisica) {
        return util.mapearObjetos(this.formulario.informacoes.pessoais, {})
      }

      return util.mapearObjetos(this.formulario.informacoes.empresariais, {})
    },

    validarDadosFormulario () {
      this.ActionResetarDadosRetornoCadastro()
      const formulario = this.tratarDadosFormulario()
      if (util.valorVazio(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'Este campo é obrigatório'
      }

      if (this.ehPessoaFisica && !valorEhCpf(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'O campo CPF é inválido.'
      }
      if (!this.ehPessoaFisica && !valorEhCnpj(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'O campo CNPJ é inválido.'
      }

      const validacaoOk = Object.values(this.dadosRetorno.listaDeErros).length === 0
      return validacaoOk
    },

    tratarDadosFormularioInformacoes () {
      const dadosFormularioInformacoes = util.mapearObjetos(this.formulario.informacoes, {})
      const dadosFormularioInformacoesAdicionais = this.obterDadosFormularioInformacoesAdicionais()

      return {
        observacoes: dadosFormularioInformacoes.observacoes,
        status: dadosFormularioInformacoes.status,
        logotipo: dadosFormularioInformacoes.logotipo,
        endereco_logotipo: dadosFormularioInformacoes.endereco_logotipo,
        codigo_empresa: dadosFormularioInformacoes.codigo_empresa,
        ...dadosFormularioInformacoesAdicionais
      }
    },

    tratarDadosFormulario () {
      const dadosFormularioEndereco = util.mapearObjetos(this.formulario.endereco, {})
      const dadosFormularioContato = util.mapearObjetos(this.formulario.contato, {})
      const dadosFormularioInformacoes = this.tratarDadosFormularioInformacoes()
      let dadosFormulario = {
        id: this.formulario.id,
        ...dadosFormularioInformacoes,
        ...dadosFormularioEndereco,
        ...dadosFormularioContato
      }

      dadosFormulario.data_nascimento = util.formatarData(dadosFormulario.data_nascimento, 'DD/MM/YYYY')
      // dadosFormulario.representante_legal = cadastroUtil.obterCodigoCombo({ campo: dadosFormulario.representante_legal })
      dadosFormulario.uf = cadastroUtil.obterCodigoCombo({ campo: dadosFormulario.uf })
      dadosFormulario.cep = util.apenasNumeros(dadosFormulario.cep)
      dadosFormulario.celular = util.apenasNumeros(dadosFormulario.celular)
      dadosFormulario.fone = util.apenasNumeros(dadosFormulario.fone)
      this.aplicarDocumentoNormalizadoCadastro(dadosFormulario)

      return dadosFormulario
    },

    aplicarDocumentoNormalizadoCadastro (dadosFormulario) {
      const documentoFederalInformadoNoFormulario = dadosFormulario.cpf_cnpj
      const documentoFederalNormalizadoParaPersistencia = this.normalizarDocumentoCadastro(documentoFederalInformadoNoFormulario)
      dadosFormulario.cpf_cnpj = documentoFederalNormalizadoParaPersistencia
    },

    normalizarDocumentoCadastro (valor) {
      if (this.ehPessoaFisica) {
        return cpf.normalizarCpf(valor)
      }

      return cnpj.normalizarCnpj(valor)
    },

    async executarSalvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const dadosFormulario = this.tratarDadosFormulario()
        const formData = this.montarObjetoDeEnvio(dadosFormulario)
        await this.ActionSalvarEscritorio(formData)

        // salva as configurações de produto na mesma ação (endpoint próprio no back-end = Task 5)
        if (this.deveSalvarProdutos) {
          await this.ActionSalvarProdutos({ idEmpresa: this.obterIdEmpresa })
        }

        this.resetarFlagAbasDoUsuario()
        this.limparFlagErroNoFormulario()
        this.tratarAposSalvarRegistro()
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const formData = new FormData()
      const campos = Object.entries(dadosFormulario)
      const logotipo = ['logotipo']
      const camposIgnorados = [...logotipo, 'tipo']

      for (let [chave, valor] of campos) {
        if (!camposIgnorados.includes(chave)) {
          formData.append(chave, valor)
        }

        if (logotipo.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, valor, valor.nome)
        }
      }
      return formData
    },

    async tratarAposSalvarRegistro () {
      this.flagsDeControle.avisoDeErroNoFormulario = util.obterDadosAlertaAposSalvarRegistro(this.dadosRetorno)
      if (this.flagsDeControle.avisoDeErroNoFormulario.exibir) {
        this.obterAbaDoComErro()
      } else {
        util.criarAlertaToastDeSucesso(this.$root, 'Aviso', 'Dados salvos com sucesso.')
        this.$router.push({ name: 'escritorios' })
      }
    },

    obterAbaDoComErro () {
      const erros = Object.keys(this.dadosRetorno.listaDeErros)
      const camposInformacoes = Object.keys(this.formulario.informacoes)
      const camposInformacoesPessoais = Object.keys(this.formulario.informacoes.pessoais)
      const camposInformacoesEmpresariais = Object.keys(this.formulario.informacoes.empresariais)
      const camposEndereco = Object.keys(this.formulario.endereco)
      const camposContato = Object.keys(this.formulario.contato)

      const errosInformacoes = camposInformacoes.some(campo => erros.includes(campo))
      const errosInformacoesPessoais = camposInformacoesPessoais.some(campo => erros.includes(campo))
      const errosInformacoesEmpresariais = camposInformacoesEmpresariais.some(campo => erros.includes(campo))

      this.flagAbas.endereco = camposEndereco.some(campo => erros.includes(campo))
      this.flagAbas.informacoes = errosInformacoes || errosInformacoesEmpresariais || errosInformacoesPessoais
      this.flagAbas.contato = camposContato.some(campo => erros.includes(campo))
    },

    resetarFlagAbasDoUsuario () {
      this.flagAbas = {
        informacoes: false,
        contato: false,
        endereco: false
      }
    },

    definirFlagErroNoFormulario (status, mensagem) {
      this.flagsDeControle.avisoDeErroNoFormulario.exibir = status
      this.flagsDeControle.avisoDeErroNoFormulario.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    limparFlagErroNoFormulario () {
      this.definirFlagErroNoFormulario(false, '')
    },
    limparCampos () {
      if (this.ehPessoaFisica) {
        this.ActionResetarDadosEmpresariaisFormularioEscritorio()
        return
      }
      this.ActionResetarDadosPessoaisFormularioEscritorio()
    },

    async eventoClickConsumos () {
      if (!this.tabelaConsumoSemRegistros) return
      await this.obterListaMonitoramentoConsumo()
    },
    async eventoClickRecursos () {
      this.selecionarAba('recursos')
      await this.obterListaMonitoramentoRecurso()
    },
    async obterListaMonitoramentoConsumo () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.post('/escritorios/escritorio/consumo', { id: this.formulario.id })
        if (resposta.data.retorno.dados.length > 0) {
          this.listaConsumos = resposta.data.retorno.dados
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async obterListaMonitoramentoRecurso () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.post('/escritorios/escritorio/recurso', { id: this.formulario.id })
        if (resposta.data.retorno.dados.recursos.length > 0) {
          this.listaRecursos = resposta.data.retorno.dados.recursos
          this.informacoesContrato = resposta.data.retorno.dados.informacoes?.contrato_principal
        } else {
          this.listaRecursos = []
        }
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.listaRecursos = []
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        }
      }
      this.definirFlagCarregandoDados(false, '')
    },
    eventoClickProdutos () {
      if (this.flagsDeControle.carregandoDados.status) {
        return
      }
      this.selecionarAba('produtos')
    },
    eventoClickPedidos () {
      this.selecionarAba('pedidos')
    },
    eventoClickFaturas () {
      if (this.flagsDeControle.carregandoDados.status) {
        return
      }
      this.selecionarAba('faturas')
    },
    selecionarAba (abaSelecionada) {
      this.abaSelecionada = Object.keys(this.abaSelecionada).reduce((acumulador, aba) => {
        const mesmaAba = aba === abaSelecionada
        acumulador[aba] = mesmaAba
        // this.visibilidadeAbas[aba] = mesmaAba
        return acumulador
      }, {})
    },
    cancelamentoConta (contratoId, informacoesContrato) {
      this.$refs.contratoModalVerificaCancelamento.abrirModalVerificaCancelamento(
        contratoId,
        '1',
        informacoesContrato,
        true
      )
    },
    async redirecionarParaListagemEscritorios () {
      this.$router.push({ name: 'escritorios' })
    },

    eventoClickUsuarios () {
      if (this.flagsDeControle.carregandoDados.status) {
        return
      }
      this.selecionarAba('usuarios')
    },

    definirValorDefaultVisibilidadeAbas () {
      const ehEmpresaOffice = this.ehEmpresaOffice
      // Produtos: exclusivo do contexto Office E atrás da feature flag (default desabilitado)
      this.visibilidadeAbas.produtos = ehEmpresaOffice && !!this.gestaoProdutosHabilitado
      this.visibilidadeAbas.recursos = !ehEmpresaOffice
      this.visibilidadeAbas.pedidos = (!ehEmpresaOffice && !this.formulario.informacoes.data_inativacao)
      this.visibilidadeAbas.faturas = (!ehEmpresaOffice && !this.formulario.informacoes.data_inativacao)
      this.visibilidadeAbas.usuarios = !ehEmpresaOffice
    }
  }
}
